import { render, staticRenderFns } from "./MatterCategoryView.vue?vue&type=template&id=83e735e4&scoped=true"
import script from "./MatterCategoryView.vue?vue&type=script&lang=js"
export * from "./MatterCategoryView.vue?vue&type=script&lang=js"
import style0 from "./MatterCategoryView.vue?vue&type=style&index=0&id=83e735e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e735e4",
  null
  
)

export default component.exports